import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { Iconify } from 'src/components';

/**
 * Helper to strip HTML tags from text
 */
const stripHtmlTags = (html) => {
  if (!html || typeof html !== 'string') return html;
  // Remove HTML tags
  return html.replace(/<[^>]*>/g, '').trim();
};

/**
 * HintAlert - Displays extracted hint messages from $Hint: patterns
 * Shows as a highlighted alert box with lightbulb icon
 */
const HintAlert = ({ text, sx = {} }) => {
  if (!text) return null;

  // Strip any HTML tags from the text
  const cleanText = stripHtmlTags(text);

  if (!cleanText) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: '0.625rem',
        padding: '0.875rem 1rem',
        bgcolor: 'rgba(255, 193, 7, 0.12)',
        border: '1px solid rgba(255, 193, 7, 0.3)',
        borderRadius: '0.5rem',
        marginBottom: '1rem',
        ...sx,
      }}
    >
      <Iconify
        icon="mdi:lightbulb-on"
        width={20}
        height={20}
        sx={{ color: '#B76E00', flexShrink: 0, mt: '2px' }}
      />
      <Typography
        sx={{
          fontSize: '0.875rem',
          color: '#7A4F01',
          lineHeight: 1.6,
          fontWeight: 500,
        }}
      >
        {cleanText}
      </Typography>
    </Box>
  );
};

HintAlert.propTypes = {
  text: PropTypes.string,
  sx: PropTypes.object,
};

export default HintAlert;
